import _ from 'underscore';
import signals from 'signals';
import I from 'immutable';
import inherits from '../utils/inherits.js';

const Store = function () {};

_.extend(Store.prototype, {
  mount(flux) {
    this._setState(
      _.extend(this.getInitialState(), flux.getStoreState(this.name) || {})
    );
    this._configureActions();
    this.dispatchToken = flux._dispatcher.register(
      _.bind(this._handleAction, this)
    );
    this.changed = new signals.Signal();
  },

  getInitialState() {
    return {};
  },

  _handleAction(action) {
    const handler = this._actionMap[action.actionType];
    const oldState = this.state;
    if (typeof handler === 'function') {
      handler.apply(this, action.args);

      if (!I.is(oldState, this.state)) {
        // Defer the dispatch to views, to end the
        // "action dispatching" scope here.
        const _this = this;
        _.defer(function () {
          _this.changed.dispatch(_this.name, _this.state);
        });
      }
    }
  },

  _setState(data) {
    this.state = I.fromJS(data || this.getInitialState());
  },

  _configureActions() {
    const self = this;
    this._actionMap = {};

    if (this.actions === undefined) {
      return;
    }

    this.actions.forEach(function (actionDefinition) {
      self._configureAction(...actionDefinition);
    });
  },

  _configureAction(name, handler) {
    this._validateActionDefinition(name, handler);
    this._actionMap[name] = _.bind(handler, this);
  },

  _validateActionDefinition(name, handler) {
    if (name === undefined || typeof handler !== 'function') {
      throw new Error('Action is not defined correctly');
    }
  },
});

Store.extend = function (ChildProto) {
  const ChildStore = function () {
    Store.call(this);
  };

  inherits(ChildStore, Store);
  _.extend(ChildStore.prototype, Store.prototype);

  if (ChildProto) {
    _.extend(ChildStore.prototype, ChildProto);
  }

  return ChildStore;
};

export default Store;
